<template>
    <div class="bill-block" id="bill-block">
        <div class="info-title">我的账单</div>
        <!-- <div class="filter-layer">
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="90px">
                <el-form-item label="查询条件" prop="condition">
                    <el-input v-model="queryParams.condition" placeholder="请输入查询条件" clearable size="small" />
                </el-form-item>
                <el-form-item label="联系人类型" prop="subject">
                    <el-select v-model="queryParams.subject" placeholder="请选择联系人类型" clearable size="small">
                        <el-option label="个人" value="person"></el-option>
                        <el-option label="企业" value="company"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="toQuery"
                        style="margin-left: 8px">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" size="small" @click="toExport">导出列表</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-row class="run-layer">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="toAdd">新增</el-button>
        </el-row> -->

        <div class="table-layer" style="padding: 0 20px 20px;">
            <el-table ref="listTableRef" :data="billList"
                :header-cell-style="{ background: '#F2F3F5', color: '#1D2129', fontWeight: 500, padding: '12px 10px' }"
                :cell-style="{
                    color: '#313843',
                    fontWeight: 400,
                    padding: '12px 10px'
                }" height="100%">

                <el-empty description="暂无数据" slot="empty" :image="require('@/assets/images/home/default.png')"
                    :image-size="220">
                </el-empty>
                <!-- <el-table-column type="index" label="序列号" width="80"></el-table-column> -->
                <el-table-column prop="orderNumber" label="订单号" width="190" show-overflow-tooltip></el-table-column>
                <el-table-column prop="unitPrice" label="套餐价格" width="100"></el-table-column>
                <el-table-column prop="unitCount" label="套数个数" width="100"></el-table-column>
                <el-table-column prop="amount" label="应付金额" width="100"></el-table-column>
                <el-table-column prop="quantity" label="签署份数" width="100"></el-table-column>
                <el-table-column prop="status" label="支付状态" width="100">
                    <template slot-scope="scope" width="100">
                        <div class="scope-content">
                            <div class="flex-center" v-if="scope.row.status == 'notPay'">
                                <span class="dot" style=" background: #EA8B56"></span>
                                <span>待支付</span>
                            </div>
                            <div class="flex-center" v-if="scope.row.status == 'pay'">
                                <span class="dot" style=" background: #00B42A"></span>
                                <span>支付成功</span>
                            </div>
                            <div class="flex-center" v-if="scope.row.status == 'failPay'">
                                <span class="dot" style=" background: #EC5B56"></span>
                                <span>审核失败</span>
                            </div>
                            <div class="flex-center" v-if="scope.row.status == 'passPay'">
                                <span class="dot" style=" background: #00D4CD"></span>
                                <span>审核通过</span>
                            </div>
                            <div class="flex-center" v-if="scope.row.status == 'processing'">
                                <span class="dot" style=" background: #CCCCCC"></span>
                                <span>审核中</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="payType" label="支付方式" width="100">
                    <template slot-scope="scope">
                        <div class="scope-content">
                            <span v-if="scope.row.payType == 'zfb'">支付宝</span>
                            <span v-else-if="scope.row.payType == 'wx'">微信</span>
                            <span v-else-if="scope.row.payType == 'yl'">银联</span>
                            <span v-else-if="scope.row.payType == 'hzd'">电汇</span>
                            <span v-else>-</span>
                        </div>
                    </template>
                </el-table-column>
<!--                <el-table-column prop="usedNumber" label="使用数量" width="100" />-->
<!--                <el-table-column prop="surplus" label="剩余数量" width="100" />-->
<!--                <el-table-column prop="expirationTime" label="过期时间" width="190">-->
<!--                    <template slot-scope="scope">-->
<!--                        <div class="scope-content">-->
<!--                            <span v-if="scope.row.expirationTime">{{ scope.row.expirationTime }}</span>-->
<!--                            <span v-else>-</span>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column prop="createTime" label="创建时间" width="190">
                    <template slot-scope="scope">
                        <div class="scope-content">
                            <span v-if="scope.row.createTime">{{ scope.row.createTime }}</span>
                            <span v-else>-</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" width="120" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.remark">
                            <span class="remark-text">{{ scope.row.remark }}</span>
                        </div>
                        <div v-else>
                            <span class="remark-text">-</span>
                        </div>
                    </template>

                </el-table-column>
                <el-table-column label="操作" fixed="right" width="90">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == 'notPay'">
                            <el-button type="text" @click="toPay(scope.row)" v-if="scope.row.status == 'notPay'">去支付
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <transition name="el-zoom-in-bottom">
                <span class="top-btn" v-show="topBtnShow" @click="handleListTable2Top"></span>
            </transition>
        </div>

        <div class="pager-layer">
            <el-pagination v-if="billList && billList.length" :total="total" :current-page.sync="queryParams.pageNum"
                layout="sizes, total, prev, pager, next" :page-sizes="[5, 10, 20, 100]"
                :page-size.sync="queryParams.pageSize" @size-change="sizeChange" @current-change="pageChange" />
        </div>
    </div>
</template>
<script>
import { getBillList } from "@/api/bill";
import { mapState } from "vuex";
export default {
    data() {
        return {
            loaded: false,
            billList: [],
            dialogVisible: false,
            sealId: "",
            queryParams: {
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            // page: 1,
            submitLoading: false,
            topBtnShow: false
        };
    },
    computed: mapState(["companyList", "currentSpace", "userInfo"]),
    created() {
        this.getBillList();
    },
    mounted() {
        window
            .addEventListener("scroll", (e) => {
                if (this.$refs.listTableRef) {
                    let target = this.$refs.listTableRef.$el.querySelector(".el-table__body-wrapper");
                    e.preventDefault();
                    // e.stopPropagation();
                    if (target.scrollTop > 100) {
                        this.topBtnShow = true;
                    } else {
                        this.topBtnShow = false;
                    }
                }
            }, true)
    },
    methods: {
        getBillList() {
            getBillList(this.queryParams)
                .then((res) => {
                    this.loaded = true;
                    if (res.code != 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        this.loaded = false;
                        this.billList = res.rows;
                        this.total = res.total;

                        document.querySelector(".el-table .el-table__fixed-right").style.maxHeight = 46 * (this.billList.length + 1) + 'px';
                        document.querySelector(".el-table .el-table__fixed-right").style['box-shadow'] = '-2px 0px 2px 0px rgba(0,0,0,0.1)';
                        document.querySelector(".table-layer").style.height = document.getElementById("bill-block").offsetHeight - 60 - 60 + "px";
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleListTable2Top() {
            this.$refs.listTableRef.$el.querySelector(".el-table__body-wrapper").scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        },
        sizeChange() {
            this.toQuery();
        },
        pageChange() {
            this.toQuery();
        },
        toQuery() {
            this.getBillList();
        },

        toPay(row) {
            this.$router.push({
                path: "/cart/order",
                query: {
                    orderId: row.id
                },
            });
        },


    },
};
</script>
<style scoped>
.text-btn {
    color: #666666 !important;
}

.text-btn:hover {
    color: #4489ee !important;
}

.filter-layer .el-form .el-form-item {
    margin-bottom: 0;
}
</style>
<style lang="scss" scoped>
.el-submenu.is-active .el-submenu__title {
    border-left: 3px solid #3296fa;
}

.scope-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.filter-layer {
    // height: 100px;
    padding-left: 22px;
    padding-top: 30px;
    // margin-bottom: 20px;
}

.run-layer {
    padding-left: 42px;
    padding-top: 30px;
    margin-bottom: 20px;
}

.remark-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
<style lang="scss" scoped>
.bill-block {
    position: relative;
    height: 100%;
}

.info-title {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    font-weight: 500;
    color: #1D2129;
    border-bottom: 1px solid #F2F3F5;
    padding-left: 22px;
}

.el-table {
    min-height: 360px;
}

.filter-layer {
    padding: 16px 0 16px 20px;

    .el-button /deep/ span {
        display: flex;
        align-items: center;

        .svg-icon {
            margin-right: 7px;
        }
    }
}

.pager-layer {
    width: 100%;
    height: 60px;
    padding-right: 20px;
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: #fff;
    z-index: 99;
}

.el-form-item {
    margin-right: 24px;
    margin-bottom: 16px;
    height: 32px;
    line-height: 32px;

    /deep/ .el-form-item__label {
        font-size: 14px;
        font-weight: 400;
        color: #4E5969;
    }

    // &+.el-form-item {
    //     // margin-left: 24px;


    // }

    .el-button {
        min-width: 84px;
    }
}

.el-input {
    height: 32px;
    line-height: 32px;

    /deep/ .el-input__inner {
        width: 240px;
    }
}

.el-select {
    /deep/ .el-input__inner {
        // width: 240px;
        width: 212px;
    }
}

.table-layer {
    margin-top: 20px;
    height: auto;
    padding-right: 20px;

    .top-btn {
        display: block;
        width: 60px;
        height: 60px;
        background: url(../../assets/icons/png/icon-top.png) center no-repeat;
        background-size: 100%;
        // box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.1);
        // border: 1px solid rgba(220, 220, 220, 0.5);
        position: absolute;
        right: 40px;
        bottom: 68px;
        z-index: 999;
        color: #93A4BC;
        padding: 0;
        cursor: pointer;
    }

    .dot {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 3px;
        margin-right: 8px;
    }

    /deep/ .selection-column .cell {
        padding-left: 12px !important;
    }

}

.el-table {
    width: 100%;

    /deep/ .el-table__row td:nth-last-of-type(1) .cell,
    /deep/ thead th:nth-last-of-type(1) .cell {
        padding-left: 14px !important;
    }

    // /deep/ .cell {
    //     padding-left: 14px !important;
    //     padding-right: 10px !important;
    //     // padding: 0 !important;
    // }

    /deep/ .el-table__cell {
        height: 46px;
        padding: 0 !important;
    }

    /deep/ .el-table__fixed,
    /deep/ .el-table__fixed-right {
        // box-shadow: -2px 0px 2px 0px rgba(0, 0, 0, 0.1);
        box-shadow: none;
        height: 0;
    }

    /deep/ .el-table__body-wrapper.is-scrolling-right~.el-table__fixed-right {
        box-shadow: none;
    }

    .el-button--text {
        font-size: 14px;
        font-weight: 400;
        color: #165DFF;
        padding: 0;

        &.grey {
            color: #86909C;
        }

        &:hover {
            opacity: .7;
        }

        &.danger {
            color: #EC5B56;
        }

    }

    .el-button+.el-button {
        margin-left: 11px;
    }
}
</style>
